<template>
<div>

    <vx-card class="">
        <!-- <v-select class="searchSelect" placeholder="검색조건"  :value="page.pageSize" v-model='page.pageSize' :clearable="false" :options="optionData.showNumber"/> -->
        <div class="w-full ">
            <div class="vx-row  w-full mb-6 items-center">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>작성자 </span>
                </div>
                <div class="vx-col sm:w-5/6 w-full ">
                    <vs-input class="w-full mr-2" v-model="dataTemplate.user.email"/>
                </div>
            </div>
            <div class="vx-row  w-full mb-6 items-center">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>대화내역 </span>
                </div>
                <div class="vx-col sm:w-5/6 w-full ">
                    <div v-for="message in dataTemplate.ticket_messages" :key="message.id" class="mb-4">
                        <div v-if="message.author.role == 'admin'" class="ticketAdmin">
                            <div class="mb-2"> <span>답변</span> {{ message.author.role == 'admin' ? '관리자' : message.author.email }}</div>
                            <div v-html="message.body"></div>
                            <div v-if="message.file" class="attachment-section">
                                <div class="attachment-label">첨부파일</div>
                                <a v-if="isImageMime(message.file.mimetype)"
                                   :href="message.file.remote_path" target="_blank"
                                   class="attachment-image-wrap">
                                    <img :src="message.file.remote_path" :alt="message.file.display_name" class="attachment-thumb" />
                                </a>
                                <a v-else :href="message.file.remote_path" target="_blank" class="attachment-file-chip">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"/>
                                    </svg>
                                    <span>{{ message.file.display_name }}</span>
                                    <span class="attachment-size">{{ formatFileSize(message.file.size) }}</span>
                                </a>
                            </div>
                            <p>{{ fixDate(message.created_at, 'yyyy-MM-dd HH:mm:ss') }}</p>
                        </div>
                        <div v-else class="ticketUser">
                            <div class="mb-2"><span>질문</span> {{ message.author.role == 'admin' ? '관리자' : message.author.email }}</div>
                            <div v-html="message.body"></div>
                            <div v-if="message.file" class="attachment-section">
                                <div class="attachment-label">첨부파일</div>
                                <a v-if="isImageMime(message.file.mimetype)"
                                   :href="message.file.remote_path" target="_blank"
                                   class="attachment-image-wrap">
                                    <img :src="message.file.remote_path" :alt="message.file.display_name" class="attachment-thumb" />
                                </a>
                                <a v-else :href="message.file.remote_path" target="_blank" class="attachment-file-chip">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"/>
                                    </svg>
                                    <span>{{ message.file.display_name }}</span>
                                    <span class="attachment-size">{{ formatFileSize(message.file.size) }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="vx-row w-full mb-6 items-center">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>답변 </span>
                </div>
                <div class="vx-col sm:w-5/6 w-full ">
                    <VueEditor
                        v-model="text"
                        id="editor"
                        useCustomImageHandler
                        @image-added="handleImageAdded"
                    />
                    
                </div>
            </div>
        </div>
        <!-- <div class="paginationBox">
            <base-pagination :page-count="page.totalPage" v-model="page.currentPage"></base-pagination>
        </div> -->
    </vx-card>
    <div class="vx-row">
        <div class="vx-col m-auto mt-6">
            <vs-button color="danger" v-on:click="$router.push('/support/faq')" type="filled">취소</vs-button>
            <vs-button class="ml-3"  @click="dataSave('confirm')" type="filled">저장</vs-button>
        </div>
    </div>
     
</div>
</template>

<script>
import Vue, { del } from 'vue'
import isEmpty from 'lodash/isEmpty'
import optionData from '@/optionData/data'
import { VueEditor } from "vue2-editor";
import axios from 'axios'
export default {
    name: 'genreList',
    components: {
        VueEditor
    },
    data () {
        return {
            fileUrl: `${process.env.VUE_APP_API_URL}/file`,
            headers: {
            Authorization: `Bearer ${localStorage.getItem('srAccessToken')}`,
            'Access-Control-Allow-Origin': '*',
            },
            dataTemplate : {
                subject : '',
                sequence_nr: 1,
                content: null,
            },
            text:null,
        }
    },
    created(){
        if(this.$route.query.page){
            this.page.currentPage= Number(this.$route.query.page)
        }
        if(this.$route.query.keywordType){
            this.keywordType= this.$route.query.keywordType
        }
        if(this.$route.query.keyword){
            this.keyword= this.$route.query.keyword
        }
        
    },
    mounted(){
        this.$nextTick(() =>{
         this.callList()
        })
    },
    computed: {
    
    },
    watch: {
       
    },
    methods: {
        callList(){
            const option = {
                id: this.$route.params.id
            }
            
             
            this.$store.dispatch('DETAIL_TICKET', option)
            .then(result =>{
                this.loadingHide()
                this.dataTemplate  = result // 권리자 목록
                
                
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        
        handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
            // An example of using FormData
            // NOTE: Your key could be different such as:
            // formData.append('file', file)
            var formData = new FormData();
            formData.append("file", file);
            axios({
                url: this.fileUrl,
                method: "POST",
                data: formData,
                headers: {
                "Content-Type": "multipart/form-data",
                ...this.headers 
                }   
            }).then(result => {
                console.log(result)
                const url = result.data[0].remote_path; // Get url from response
              
                setTimeout(() => {
                      Editor.insertEmbed(cursorLocation, "image", url  );
                }, 500);
                resetUploader();
            })
            .catch(err => {
                console.log(err);
            });
        },
        isImageMime(mimetype) {
            return typeof mimetype === 'string' && mimetype.startsWith('image/')
        },
        formatFileSize(bytes) {
            const n = parseInt(bytes, 10)
            if (isNaN(n)) return ''
            if (n < 1024) return n + ' B'
            if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' KB'
            return (n / (1024 * 1024)).toFixed(1) + ' MB'
        },
        dataSave(event){
            let payload ={
                body : this.text,
                id : this.dataTemplate.id
            }
            if(this.valCheck(this.text) ){
                this.alert({msg : '내용을 확인해주세요.'})
                return false
            }
            
            this.loadingShow()
            this.$store.dispatch('POST_TICKET_MESSAGE', payload)
            .then(result =>{
                this.text = null
                this.loadingHide()
                this.callList()
                
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        }
    }
}
</script>

<style scoped>
.attachment-section {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.attachment-label {
    font-size: 11px;
    color: #64748b;
    margin-bottom: 6px;
    font-weight: 500;
    letter-spacing: 0.02em;
}

.attachment-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.attachment-image-wrap {
    display: inline-block;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.1);
    transition: opacity 0.15s ease, transform 0.15s ease;
    cursor: pointer;
}

.attachment-image-wrap:hover {
    opacity: 0.85;
    transform: scale(1.02);
}

.attachment-thumb {
    display: block;
    width: 80px;
    height: 80px;
    object-fit: cover;
}

.attachment-file-chip {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    border-radius: 20px;
    font-size: 12px;
    color: #2563eb;
    text-decoration: none;
    max-width: 200px;
    transition: background 0.15s ease, border-color 0.15s ease;
    cursor: pointer;
}

.attachment-file-chip:hover {
    background: #dbeafe;
    border-color: #93c5fd;
}

.attachment-file-chip span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.attachment-file-chip svg {
    flex-shrink: 0;
    color: #2563eb;
}

.attachment-size {
    flex-shrink: 0;
    font-size: 11px;
    color: #94a3b8;
}
</style>
